export default (settings: any) => settings['messages'] * 0.5
